import { render, staticRenderFns } from "./ItemUploadOptions.vue?vue&type=template&id=b90c125e&scoped=true&"
import script from "./ItemUploadOptions.vue?vue&type=script&lang=js&"
export * from "./ItemUploadOptions.vue?vue&type=script&lang=js&"
import style0 from "./ItemUploadOptions.vue?vue&type=style&index=0&id=b90c125e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90c125e",
  null
  
)

export default component.exports